import styled from '@emotion/styled';

export const ErrorDisplayContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '15px',
  padding: '20px',
  backgroundColor: 'rgba(255, 50, 50, 0.35)',
  border: `2px solid ${theme.colors?.kitopiSemanticColors.error300}`,
  borderRadius: '12px',
  margin: '20px 0',
  boxSizing: 'border-box',
  minWidth: '350px',
  width: '100%',
}));

export const ErrorDisplayMessage = styled('div')(({ theme }) => ({
  color: theme.colors?.kitopiColors.kitopiWhite,
  fontSize: '16px',
  fontWeight: 500,
  textAlign: 'center',
  lineHeight: 1.5,
}));
